import { useI18n } from 'vue-i18n';
import { useNotify } from '@/components/utils/notifications';
import { useFetchAction, type ApiRequestInit } from './fetch';
import { useDeletePrompt } from '@/components/utils/prompt/injects';

/* eslint-disable import/prefer-default-export */
export const useDelete = (message?: string) => {
  const notify = useNotify();
  const [exec, state] = useFetchAction();
  const { t } = useI18n();

  const promptDelete = useDeletePrompt();

  const deleteFn = async (url: string, props?: ApiRequestInit) => {
    try {
      const answer = await promptDelete?.(message);
      if (!answer) return answer ?? false;
      // TODO: Also delete all the files first, otherwise there is a server error (foreign key constraint)!
      await exec(url, {
        method: 'DELETE',
        ...props,
      });

      notify?.({
        variant: 'success',
        title: t('deleteSuccess'),
      });
      return true;
    } catch (e) {
      notify?.({
        variant: 'error',
        title: t('deleteError'),
      });
      return false;
    }
  };

  return [deleteFn, state] as [typeof deleteFn, typeof state];
};
